import {IntlShape} from 'react-intl';

import {AlertEpisodeDisplayedState, ALERT_EPISODE_NOT_ACTIVE_STATES} from './alert_types';

/** "DD.MM" of an ISO date or date-time, as the design writes snooze and menu dates ("Snoozed · 21.07"). */
export function formatDayMonth(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (m) return `${m[3]}.${m[2]}`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function isNotActiveState(state: AlertEpisodeDisplayedState): boolean {
  return ALERT_EPISODE_NOT_ACTIVE_STATES.includes(state);
}

/** The filter criteria as a plain object, whatever the BE sends (an object, or the stored JSON string). */
export function parseFilterData(data: Record<string, unknown> | string | null | undefined): Record<string, unknown> {
  if (!data) return {};
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }
  return data;
}

/** The placeholder of a cell or tile with nothing to compute (no solved episode, a zero denominator). */
export const ALERT_EMPTY_VALUE = '\u2014';

type NumberFormatter = Pick<IntlShape, 'formatNumber'>;

/** A solved rate as the board shows it: the unrounded percentage from core rounded to a whole percent ("33%"). */
export function formatAlertSolvedRate(rate: number | null | undefined, intl: NumberFormatter): string {
  if (rate == null || Number.isNaN(Number(rate))) return ALERT_EMPTY_VALUE;
  return `${intl.formatNumber(Math.round(Number(rate)))}%`;
}

/** An average time to solve, in days to one decimal as core rounds it, without the unit ("1.8", "1,8"). */
export function formatAlertAvgDays(days: number | null | undefined, intl: NumberFormatter): string | null {
  if (days == null || Number.isNaN(Number(days))) return null;
  return intl.formatNumber(Number(days), {minimumFractionDigits: 1, maximumFractionDigits: 1});
}
